/**
 * Stable id helper that links a slide (tabpanel) to its dot (tab) for ARIA.
 *
 * The single source of truth for the slide id convention so that
 * server-rendered slides and the client-side dots agree without each side
 * re-deriving the string template. Custom, portal-specific slide markup can
 * import this to stay wired to the shared controls.
 */
export const getSlideId = (idx: number): string => `hero-carousel-slide-${idx + 1}`;
